// src/App.jsx
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import AppShell from "./layout/AppShell";

import IngestMonitor from "./screens/IngestMonitor";
import PipelineHome from "./screens/Pipeline"; // se quiser manter como tela, mas ideal virar redirect
import IngestDashboard from "./screens/IngestDashboard";

// TODO: trocar depois quando existirem telas reais
import SalesHome from "./screens/IngestDashboard";
import SupportHome from "./screens/IngestDashboard";
import PerfDashboard from "./screens/PerfDashboard";

import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";

import { AuthProvider, RequireAuth, LoginEmail, LoginOtp } from "auth";

export function useFixIOSStatusBar() {
  useEffect(() => {
    (async () => {
      if (!Capacitor.isNativePlatform()) return;
      try {
        await StatusBar.setOverlaysWebView({ overlay: true });
        await StatusBar.setStyle({ style: Style.Light });
      } catch {}
    })();
  }, []);
}

// default “landing” do app (sem Home genérica)
function getDefaultAuthedPath() {
  const last = localStorage.getItem("last_route");
  if (last && last.startsWith("/")) return last;
  return "/data-flow/dashboard";
}

export default function App() {
  useFixIOSStatusBar();

  return (
    <AuthProvider afterLoginPath="/data-flow">
      <BrowserRouter>
        <Routes>
          {/* LOGIN */}
          <Route path="/login" element={<LoginEmail />} />
          <Route path="/login/otp" element={<LoginOtp />} />

          {/* APP PROTEGIDO */}
          <Route element={<RequireAuth loginPath="/login" />}>
            <Route element={<AppShell />}>
              {/* raiz: vai para última rota ou Data Flow Dashboard */}
              <Route path="/" element={<Navigate to={getDefaultAuthedPath()} replace />} />

              {/* SALES */}
              {/* <Route path="/sales" element={<Navigate to="/sales/overview" replace />} />
              <Route path="/sales/overview" element={<SalesHome />} />
     */}
              {/* DATA FLOW (antigo /ingest) */}
              <Route path="/data-flow" element={<Navigate to="/data-flow/dashboard" replace />} />
              {/* Se você quiser manter o caminho antigo por compatibilidade: */}
              <Route path="/ingest" element={<Navigate to="/data-flow/dashboard" replace />} />

              <Route path="/data-flow/live" element={<IngestMonitor />} />
              <Route path="/data-flow/dashboard" element={<IngestDashboard />} />
              <Route path="/data-flow/pipeline" element={<PipelineHome />} />
              {/* Se preferir usar FleetLive como Live em vez de IngestMonitor: */}
              {/* <Route path="/data-flow/live" element={<FleetLive />} /> */}

              {/* SUPPORT */}
              {/* <Route path="/support" element={<Navigate to="/support/tickets" replace />} />
              <Route path="/support/tickets" element={<SupportHome />} /> */}
              {/* futuramente:
                  /support/alerts
                  /support/incidents
              */}

              {/* PERFORMANCE */}
              <Route path="/performance" element={<Navigate to="/performance/PerfDashboard" replace />} />
              <Route path="/performance/PerfDashboard" element={<PerfDashboard />} />
              {/* futuramente:
                  /performance/trends
                  /performance/reports
              */}

            </Route>
          </Route>

          {/* fallback: tenta última rota */}
          <Route path="*" element={<Navigate to={getDefaultAuthedPath()} replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}